import { jsx as _jsx } from "preact/jsx-runtime";
function CalendarCheck(props) {
    const { width, height, fill } = props;
    return (_jsx("svg", { ...props, width: width ?? 24, height: height ?? 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M8 1.99902V5.99934M16 1.99902V5.99934M3 9.99966H21M9 16.0001L11 18.0003L15 14M5 3.99918H19C20.1046 3.99918 21 4.89469 21 5.99934V20.0005C21 21.1051 20.1046 22.0006 19 22.0006H5C3.89543 22.0006 3 21.1051 3 20.0005V5.99934C3 4.89469 3.89543 3.99918 5 3.99918Z", stroke: fill ?? 'black', strokeWidth: "2", strokeLinecap: "round" }) }));
}
CalendarCheck.defaultProps = {
    fill: '#000',
};
export default CalendarCheck;
